import { ITheme } from "../../utils/theme";

export const summaryHeaderStyle = {
  color: (theme: ITheme) => theme.palette.common.white,
  fontSize: '18px',
  fontWeight: 'bold',
  background: (theme: ITheme) => theme.palette.blue[900],
  p: 1,
}

export const textHighlightStyle = (theme: ITheme) => ({
  color: theme.palette.red[500]
})

export const LegendContainerStyle = {
  display: "flex",
  flexDirection: "column",
  border: (theme: ITheme) => `solid 2px ${theme.palette.common.black}`,
  background: "#DDDDDD",
}

export const BodyStyle = {
  color: (theme: ITheme) => theme.palette.common.black,
  p: 1
}

export const ContentStyle = {
  fontWeight: "bold"
}

export const boxStyle = (theme: ITheme) => ({
  display: 'flex',
  alignItems: 'center',
  width: '40px',
  minWidth: '40px',
  height: '40px',
  boxSizing: 'border-box',
  border: `2px solid ${theme.palette.common.black}`,
  mr: 1,
  p: '5px',
})

export const boxWrapperStyle = {
  display: 'flex',
  mb: 1,
  alignItems: 'center',
  '&:last-of-type': {
    mb: 0
  }
}

export const tableHeadCellStyle = (theme: ITheme) => ({
  background: theme.palette.blue[300],
  color: theme.palette.common.black,
  fontWeight: 'bold',
  borderRight: `1px solid ${theme.palette.grey[300]}`,
  py: 1,
})

export const tableRowCellStyle = (theme: ITheme) => ({
  borderRight: `1px solid ${theme.palette.grey[300]}`
})

export const employeeNameCellStyle = (theme: ITheme) => (imageName: string) => ({
  borderRight: `1px solid ${theme.palette.grey[300]}`,
  backgroundImage: `
    url(../../../assets/images/${imageName}); 
    background-position: right; 
    background-repeat: no-repeat;
  `,
  '&.MuiTableCell-root.MuiTableCell-body': {
    minWidth: '250px',
  }
})

export const dispatchCellStyle = (theme: ITheme) => (borderStyle: string) => ({
  '&.MuiTableCell-root.MuiTableCell-body': {
    minWidth: '300px',
  },
  borderRight: `1px solid ${theme.palette.grey[300]}`,
  border: borderStyle,
})

export const PaginationStyle = {
  position: 'sticky',
  left: 0,
  '& .MuiPagination-ul': {
    justifyContent: 'center',
  },
  pt: 1,
  pb: 1
}